/**
 * LocalizationsCtrl controller
 * Show all localizations
 */

// controller mixins
LocalizationsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * LocalizationsCtrl controller
 *
 * @class LocalizationsCtrl
 * @memberof mwApp/localizations
 * @see mwApp/localizations
 *
 * @ngdoc controller
 * @name mwApp/localizations.controller:LocalizationsCtrl
 */
/* @ngInject */
export default function LocalizationsCtrl ($scope, Localization, authSvc) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', 'clients', 'applications']]

  vm.isFound = true
  vm.showShoppingCartTab = authSvc.hasEnabledFlag('FEATURE_SHOPPING_CART_MANAGEMENT_ENABLED') &&
    authSvc.hasEnabledFlag('FEATURE_SHOPPING_CART_LOCALIZATION_ENABLED')

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true
  vm.localizationStatuses = {
    CREATING: 'Creating',
    UPDATING: 'Updating',
    DONE: 'Done'
  }

  /**
   * Devices list
   *
   * @memberof mwApp/localizations.controller:LocalizationsCtrl
   * @type {models.Localization[]}
   */
  vm.localizations = []

  /**
   * Get Localizations from backend
   *
   * @memberof mwApp/localizations.controller:LocalizationsCtrl
   */
  vm.getLocalizations = function () {
    // set default sort by id
    Localization.loadAll({ appName: 'client-apps' })
      .then(
        data => {
          vm.clientLocalizations = data
          vm.clientLocalizationsIsFound = !!vm.clientLocalizations.length
          $scope.loading = false
        }
      )
  }
  vm.getLocalizations()
  if (vm.showShoppingCartTab) {
    /**
     * Get Localizations from backend
     *
     * @memberof mwApp/localizations.controller:LocalizationsCtrl
     */
    vm.getApplicationLocalizations = function () {
      // set default sort by id
      Localization.loadAll({ appName: 'scp' })
        .then((data) => {
          vm.applicationLocalizations = data
          vm.applicationLocalizationsIsFound = !!vm.applicationLocalizations.length
          $scope.loading = false
        })
    }
    vm.getApplicationLocalizations()
  }

  /**
   * Set payment as default
   *
   * @memberof mwApp/packages.controller:LocalizationsCtrl
   * @param  {models.Localization} localization
   */
  vm.setDefault = function (localization) {
    localization._default()
      .then(vm.location.reload)
  }

  /**
   * Delete Localization
   *
   * @memberof mwApp/localizations.controller:LocalizationsCtrl
   * @param {models.Localization} localization
   */
  vm.delete = function (localization) {
    localization._delete()
      .then(vm.location.reload)
  }

  $scope.$on('$destroy', function () {
    window.clearTimeout(vm.$timer)
  })
}
